import React, { useState } from 'react';
import Modal from './modal';
import AppButton from './button';
import Lock from '../../assets/svgs/lock.svg';
import AppCodeInput from './code-input';
import Loader from './loader';

interface CodeVerificationProps {
  isOpen: boolean;
  toggleModal: () => void;
  verifyInput: () => Promise<void>;
  loading: boolean;
  onCodeChange: (code: string) => void;
  resendCode: () => void;
  codeLength?: number;
  email: string;
}

const CodeVerification: React.FC<CodeVerificationProps> = ({
  isOpen,
  toggleModal,
  verifyInput,
  loading,
  onCodeChange,
  resendCode,
  codeLength = 6,
  email,
}) => {
  const [code, setCode] = useState('');

  return (
    <Modal isOpen={isOpen} toggleModal={toggleModal} width="w-[620px] h-fit">
      <div className="p-6">
        <h2 className="text-xl font-bold mb-4">Verification Required</h2>
        <p className="text-gray-600 mb-6">
          For security purposes, enter the {codeLength}-digit verification code
          sent to {email}.
        </p>

        <AppCodeInput
          type="text"
          name="verificationCode"
          id="verificationCode"
          onChange={(e) => {
            const code = e.target.value.replace(/\D/g, '');
            setCode(code);
            onCodeChange(code);
          }}
          value={code}
          placeholder="000000"
          required
          maxLength={codeLength}
        />

        {loading ? (
          <Loader
            width="1.2rem"
            borderTopColor="border-t-blue-500 my-4 mx-auto"
          />
        ) : (
          <div className="flex justify-center my-4">
            <p
              className="text-blue-500 cursor-pointer hover:underline"
              onClick={() => {
                setCode('');
                resendCode();
              }}
            >
              Resend verification code
            </p>
          </div>
        )}

        <div className="flex justify-end">
          <AppButton
            label="Verify & Continue"
            clicked={verifyInput}
            loading={loading}
            fullWidth
            disabled={!code || (code && code.length !== codeLength) || loading}
          />
        </div>

        <div className="flex justify-center items-center gap-4 mt-4">
          <img src={Lock} alt="Security Lock" />
          <p className="text-[#323B49] font-normal">Secured with encryption</p>
        </div>
      </div>
    </Modal>
  );
};

export default CodeVerification;
